import { ReactNode } from 'react';

export type StatTone = 'primary' | 'success' | 'danger' | 'warning' | 'neutral';

/**
 * Carte statistique compacte (libellé, valeur, icône, tonalité).
 *
 * Exemple :
 *   <StatCard label="Effectif terrain" value={2} icon={<People />} tone="primary" />
 */
const StatCard = (props: {
    label: ReactNode;
    value: ReactNode;
    sub?: ReactNode;
    icon?: ReactNode;
    tone?: StatTone;
}) => (
    <div className={`eb-stat-card tone-${props.tone || 'primary'}`}>
        <div>
            <div className="label">{props.label}</div>
            <div className="value">{props.value}</div>
            {props.sub && <div className="sub">{props.sub}</div>}
        </div>
        {props.icon && <div className="icon">{props.icon}</div>}
    </div>
);

export default StatCard;
